import styled from "styled-components";

export default styled.p`
  font-size: 16px;
  color: #ffffff;
  font-weight: 500;
  text-align: center;
  margin: 5px 0;
  margin-top: 15px;
`;
